// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7337) return "static/chunks/ad2866b8-9035c05d2ebd85e3.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8445 ? "bc98253f" : chunkId) + "." + {"3582":"d06493eeb7e4d486","7304":"bab931ec034a348a","8445":"4312cdff53b952a2"}[chunkId] + ".js";
};